export default __webpack_public_path__ + "static/O0250-8f17a5af50fc5af92687a10ec830baeb.png";